export class Filtro {
  constructor(campo, valor, tipoFiltro, relacionamento) {
    this.campo = campo
    this.valor = valor
    this.tipoFiltro = tipoFiltro
    this.relacionamento = relacionamento
  }
}
